/**
 * Wishlist Count
 */

import * as utils from "@sharedJS/utils";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

function init() {
	OcmMessenger.subscribe(messengerPublicationTypes.REMOVED_FROM_WISHLIST, wishlistChanged); // published by wishlist
	OcmMessenger.subscribe(messengerPublicationTypes.ADDED_TO_WISHLIST, wishlistChanged); // published by cart
	OcmMessenger.subscribe(messengerPublicationTypes.UPDATE_MULTIPLE_WISHLIST, updateWishlist); // published by plp and pdp

	// Make sure Wishlist count is always up to date (browser back / cache-control)
	requestWishlistItemCount();
}

function requestWishlistItemCount() {
	if (!document.querySelector(".js-wishlistCounter-badge")) {
		return;
	}

	const url = utils.getUrl("/rest/wishlist/count/");
	$.ajax({
		url,
		global: false,
		type: "GET",
		dataType: "json",
		async: true,
	})
		.done((data) => {
			writeItemCount(data);
		})
		.fail((jqXHR, textStatus, errorThrown) => {
			console.error(errorThrown);
		});
}

function updateWishlist(publication) {
	writeItemCount(publication.data.stylesOnWishlistWithSizeCode.length);
}

function wishlistChanged(publication) {
	writeItemCount(publication.data.data.count); // todo: wow
}

function writeItemCount(counter) {
	const wishlistCounterBadges = document.querySelectorAll(".js-wishlistCounter-badge");
	if (wishlistCounterBadges.length === 0) {
		return;
	}
	[...wishlistCounterBadges].forEach((badge) => (badge.textContent = counter));
}

export { init };
